import { render, staticRenderFns } from "./tree-view.vue?vue&type=template&id=84b5c776"
import script from "./tree-view.vue?vue&type=script&lang=js"
export * from "./tree-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports